import _toConsumableArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import { isEmpty } from "lodash";
/** Converts persisted OpenAI-format messages into CopilotKit message instances for display. */
export function convertOpenAIToCopilot(openaiMessages) {
  var addAssistantMessageInToolCalls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var actionNameMapToToolCallId = {};
  return openaiMessages.flatMap(function (msg) {
    var now = new Date();
    if (msg === undefined) return [];
    if ((msg === null || msg === void 0 ? void 0 : msg.role) === "user" || (msg === null || msg === void 0 ? void 0 : msg.role) === "assistant" || msg.role === "system") {
      var _msg$tool_calls;
      if (msg.tool_calls && ((_msg$tool_calls = msg.tool_calls) === null || _msg$tool_calls === void 0 ? void 0 : _msg$tool_calls.length) > 0) {
        var toolCalls = msg.tool_calls.map(function (toolCall) {
          actionNameMapToToolCallId[toolCall.id] = toolCall["function"].name;
          var parsedArguments = {};
          try {
            if (typeof toolCall["function"].arguments === "string" && toolCall["function"].arguments.startsWith("{")) {
              parsedArguments = JSON.parse(toolCall["function"].arguments);
            }
          } catch (error) {
            console.error("Error parsing tool call arguments:", error, toolCall["function"].arguments);
            parsedArguments = {
              raw: toolCall["function"].arguments
            };
          }
          return {
            id: toolCall.id,
            createdAt: new Date(toolCall.created_at || new Date()),
            type: "ActionExecutionMessage",
            name: toolCall["function"].name,
            arguments: parsedArguments
          };
        });
        if (!isEmpty(msg.content) && msg.role === "assistant" && addAssistantMessageInToolCalls) {
          return [{
            id: "assistant-".concat(crypto.randomUUID()),
            createdAt: new Date(msg.created_at || new Date()),
            type: "TextMessage",
            role: "assistant",
            content: msg.content || ""
          }].concat(_toConsumableArray(toolCalls));
        } else {
          return toolCalls;
        }
      } else {
        if (msg.role === "user") {
          return [{
            id: "ck-".concat(crypto.randomUUID()),
            createdAt: new Date(msg.created_at || new Date()),
            type: "TextMessage",
            role: msg.role,
            content: msg.content || ""
          }];
        } else {
          return [{
            id: "gen-".concat(crypto.randomUUID()),
            createdAt: new Date(msg.created_at || new Date()),
            type: "TextMessage",
            role: msg.role,
            content: msg.content || ""
          }];
        }
      }
    } else if (msg.role === "tool") {
      var result = "";
      try {
        if (typeof msg.content === "string" && msg.content.trim().startsWith("{")) {
          try {
            result = JSON.parse(msg.content);
          } catch (parseError) {
            console.warn("Failed to parse JSON content, using raw content:", parseError instanceof Error ? parseError.message : parseError);
            result = msg.content || "";
          }
        } else {
          result = msg.content || "";
        }
      } catch (error) {
        console.error("Error parsing tool call result:", error);
        result = msg.content || "";
      }
      return [{
        id: "result-".concat(msg.tool_call_id || crypto.randomUUID()),
        createdAt: now,
        type: "ResultMessage",
        actionExecutionId: msg.tool_call_id || "",
        actionName: msg.tool_call_id && actionNameMapToToolCallId[msg.tool_call_id] || "",
        result: result
      }];
    } else {
      return [{
        id: "gen-".concat(crypto.randomUUID()),
        createdAt: now,
        type: "TextMessage",
        role: msg.role,
        content: msg.content || ""
      }];
    }
  });
}